// PostHog does not push dashboard changes to an open browser. One refresh owner
// per SDK client keeps every mounted experiment in sync without per-hook polling.
const refreshOwners = new WeakMap();
export const EXPERIMENT_FLAG_REFRESH_MS = 60000;

export function watchExperimentFlags(client, onUpdate) {
  if (!client) return () => {};
  let unsubscribe;
  try {
    unsubscribe = (client.onFeatureFlags || client.featureFlags?.onFeatureFlags)?.call(
      client.onFeatureFlags ? client : client.featureFlags,
      onUpdate,
    );
  } catch {
    // The next mount still evaluates the current SDK state and fails closed.
  }
  let owner = refreshOwners.get(client);
  if (!owner) {
    const refresh = () => {
      if (document.visibilityState !== 'visible') return;
      try {
        client.reloadFeatureFlags?.();
      } catch {
        /* Retry at the next refresh. */
      }
    };
    const timer = window.setInterval(refresh, EXPERIMENT_FLAG_REFRESH_MS);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    owner = {
      count: 0,
      stop: () => {
        window.clearInterval(timer);
        window.removeEventListener('focus', refresh);
        document.removeEventListener('visibilitychange', refresh);
      },
    };
    refreshOwners.set(client, owner);
    refresh();
  }
  owner.count += 1;
  return () => {
    unsubscribe?.();
    owner.count -= 1;
    if (owner.count === 0) {
      owner.stop();
      refreshOwners.delete(client);
    }
  };
}
